/* eslint-disable import/no-anonymous-default-export */
export default {
  auth: "/auth",
  accountrecovery: "/auth/account-recovery/:token?",
  createnew: "/create-potluck",
  community: "/join-open-meets",
  contribute: "/contribute-potluck/:token",
  feedback: "/feedback",
  forgotpassword: "/auth/forgot-password/:token?",
  home: "/",
  login: "/auth/:token?",
  managepotluck: "/manage-potluck/:token",
  handler: "/handler",
  share: "/handler/share/:token",
  guest: "/handler/guest/:token",
  resetpassword: "/auth/reset-password/:token",
  summary: "/summary-potluck/:token",
  usercontributor: "/user-contributor/:token",
  useronboarding: "/auth/user-onboarding/:token?",
  userguestonboarding: "/auth/guest-onboarding/:token?",
  userdashboard: "/me",
  voting: "/user-voting/:token",
}